module.exports = __webpack_public_path__ + "static/6-58b1285102b3c1b9f5d6a4b259f3cea4.png";